export type EnqueuedFunction = () => Promise<void>;
export class SimpleQueue {
    queue: EnqueuedFunction[] = [];
    processing: boolean = false;

    push(funcArr: EnqueuedFunction|EnqueuedFunction[]) {
        if (!Array.isArray(funcArr)) funcArr = [funcArr];

        for (const func of funcArr) {
            this.queue.push(func)
        }

        void this.processQueue();
    }

    async processQueue(chain: boolean = false) {
        if (this.processing && !chain) return;

        this.processing = true;
        const currFunc = this.queue.shift();

        if (!currFunc) 
            return this.processing = false;
        
        try {
            await currFunc();
        } catch (e) {
            console.error(e);
        } finally {
            void this.processQueue(true);
        }
    }
}